import type { ReactNode } from 'react';

/** A Home sub-view (Play, Join Lobby): "← Back" and the title over its content. */
export function SubView({
  title,
  className,
  onBack,
  backDisabled,
  children,
}: {
  title: string;
  className: string;
  onBack: () => void;
  backDisabled: boolean;
  children: ReactNode;
}) {
  return (
    <section
      className={`panel home-panel home-view ${className}`}
      aria-labelledby="home-view-title"
    >
      <header className="home-view-header">
        <button className="back" data-sound="back" disabled={backDisabled} onClick={onBack}>
          ← Back
        </button>
        <h2 id="home-view-title" className="panel-title">
          {title}
        </h2>
      </header>
      {children}
    </section>
  );
}
